import React, { useEffect, useState } from 'react'
import styled from 'styled-components/macro'
import ReactGA from 'react-ga'

import Header from './Header'
import Hero from './Hero'
import Content from './Content'
import Rewards from './Rewards'
import About from './About'
import Note from './Note'
// import Floating from './Floating'
import Footer from '../../components/Footer/Footer'
import getLink from '../../utils/getLink'

const Wrapper = styled.div`
  position: relative;

  /* floating */
  /* padding-bottom: 78px; */

  /* @media only screen and (min-width: 768px) {
    padding-bottom: 64px;
  } */
`

const Home = ({ navigate, routePath, voucher, demo }) => {
  const [accepted, setAccepted] = useState(true)
  const [popupShown, setPopupShown] = useState(false)

  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search)
  }, [])

  const handleAccept = () => {
    setPopupShown(false)
    setAccepted(!accepted)
  }

  const handleGoToSurvey = () => {
    if (!accepted) {
      setPopupShown(true)
    } else {
      navigate(getLink(routePath, '/survey'))
    }
  }

  return (
    <Wrapper>
      <Header demo={demo} />
      <Hero
        goToSurvey={handleGoToSurvey}
        accepted={accepted}
        onAccept={handleAccept}
        popupShown={popupShown}
        demo={demo}
      />
      <Content />
      {voucher && <Rewards demo={demo} />}
      <About demo={demo} />
      <Note />
      {/* TODO check if needed and clean */}
      {/* <Floating
        goToSurvey={handleGoToSurvey}
        accepted={accepted}
        onAccept={handleAccept}
        popupShown={popupShown}
      /> */}
      <Footer demo={demo} />
    </Wrapper>
  )
}

export default Home
